import type { Facet, FacetOption } from '../types/Facet';

/** The active option of the facet with the given alias, if one is selected. */
export const findActiveOption = (facets: Facet[], alias: Facet['alias']): FacetOption | undefined =>
  facets.find((facet) => facet.alias === alias)?.options.find((option) => option.active);

/** The values of all active options of a facet (empty when none, or no facet). */
export const getActiveOptionValues = (facet: Facet | undefined): string[] =>
  facet?.options.filter((option) => option.active).map((option) => option.value) ?? [];
